import usePagedSortedTable from "../../Hooks/usePagedSortedTable";
const PagedAndSortedTable = (props) => {
    const { table } = usePagedSortedTable(props);
    return table;
};
export default PagedAndSortedTable;
